var TaskDirectoryHeaderLabels = {
  path: "NAME",
  mode: "PERMISSIONS",
  uid: "OWNER",
  size: "SIZE",
  mtime: "MODIFIED"
};

module.exports = TaskDirectoryHeaderLabels;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/TaskDirectoryHeaderLabels.js